import { CSSProperties, ReactNode, useState } from 'react';
import { useReduxState } from 'hooks';
import { Expand, Tooltip } from 'components/common';
import { Icon } from 'components/common/icons';

interface Props {
  children: ReactNode;
  settingsHaveBeenEdited?: boolean;
  settingsHaveBeenEditedTooltip?: string;
  style?: CSSProperties;
  title?: string;
}

const EditorBlockMoreSettings = ({
  children,
  settingsHaveBeenEdited,
  settingsHaveBeenEditedTooltip,
  style,
  title
}: Props) => {
  const { messages, theme } = useReduxState();

  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => setIsExpanded(!isExpanded);

  return (
    <div className="settings" style={style}>
      <button className="toggle" onClick={handleToggle} type="button">
        <div className="title">{title || messages.commonShowMoreOptions}</div>

        <div className="icon">
          <Icon
            icon={isExpanded ? 'chevron-up' : 'chevron-down'}
            fixedWidth={true}
          />
        </div>

        {settingsHaveBeenEdited ? (
          <Tooltip
            content={
              settingsHaveBeenEditedTooltip ||
              messages.editorBlockSettingsEdited
            }
          >
            <div className="settings-edited">
              <div className="settings-edited-inner" />
            </div>
          </Tooltip>
        ) : null}
      </button>

      <Expand isExpanded={isExpanded}>
        <div className="content">{children}</div>
      </Expand>

      <style jsx>{`
        .settings {
          background-color: ${theme.lightGreyDark};
          border-radius: ${theme.cardBorderRadius};
          margin-top: 20px;
        }
        .toggle {
          align-items: center;
          background-color: transparent;
          border: 0;
          border-radius: ${theme.cardBorderRadius};
          color: ${theme.textColorLight};
          cursor: pointer;
          display: flex;
          font-family: inherit;
          font-size: 1.5rem;
          font-weight: 600;
          gap: 5px;
          outline: 0;
          padding: 8px 15px;
          width: 100%;
        }
        .toggle:focus .title,
        .toggle:hover .title {
          text-decoration: underline;
        }
        .settings-edited {
          position: relative;
          padding: 5px;
          left: -7px;
        }
        .settings-edited-inner {
          background-color: ${theme.dangerColor};
          border-radius: 20px;
          position: relative;
          top: 1px;
          width: 6px;
          height: 6px;
        }
        .icon {
          font-size: 1.1rem;
          margin-right: 5px;
          position: relative;
          top: 1px;
        }
        .content {
          padding: 7px 15px 20px;
        }
      `}</style>
    </div>
  );
};

export default EditorBlockMoreSettings;
